module.exports = __webpack_public_path__ + "img/arrow_down.8b347e27.svg";